<template>
	<router-view />
</template>

<script>
export default {
	name: 'contility',
};
</script>